import React from "react";
import { skills } from "../data/mock";
import { useReveal } from "../hooks/useReveal";

const SectionHeading = ({ num, title }) => (
  <div className="flex items-center gap-4 mb-12 md:mb-16">
    <h2 className="flex items-baseline gap-3 whitespace-nowrap">
      <span className="font-mono text-accent text-lg md:text-xl">{num}.</span>
      <span className="font-sans text-2xl md:text-3xl font-semibold text-ink tracking-tight">
        {title}
      </span>
    </h2>
    <span className="hidden sm:block h-px flex-1 bg-rule" />
  </div>
);

const categories = [
  { label: "languages", items: () => skills.languages },
  { label: "backend", items: () => skills.backend },
  { label: "databases", items: () => skills.databases },
  { label: "messaging", items: () => skills.messageQueue },
  { label: "devops", items: () => skills.devops },
  { label: "leadership", items: () => skills.leadership },
  { label: "specializations", items: () => skills.specializations }
];

const Skills = () => {
  const revealRef = useReveal();

  return (
    <div className="py-24 md:py-32 border-t border-rule">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div ref={revealRef} className="reveal">
          <SectionHeading num="03" title="Stack" />

          {/* Stat strip */}
          <div className="grid grid-cols-3 gap-4 mb-16 md:mb-20">
            {[
              { v: skills.summary.experience, l: "years shipping" },
              { v: skills.summary.project, l: "projects delivered" },
              { v: skills.summary.mentored, l: "engineers mentored" }
            ].map((s, i) => (
              <div
                key={i}
                className="card-lift rounded-lg border border-rule bg-bg-elev p-5 md:p-6"
              >
                <div className="font-sans font-semibold text-3xl md:text-4xl text-ink tracking-tight">
                  {s.v}
                </div>
                <div className="mt-1 font-mono text-[11px] uppercase tracking-widest text-ink-3">
                  {s.l}
                </div>
              </div>
            ))}
          </div>

          {/* Terminal-like block */}
          <div className="rounded-lg border border-rule bg-bg-elev overflow-hidden">
            <div className="flex items-center justify-between px-4 py-2.5 border-b border-rule bg-bg">
              <div className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded-full bg-[#3a3a3a]" />
                <span className="w-2.5 h-2.5 rounded-full bg-[#3a3a3a]" />
                <span className="w-2.5 h-2.5 rounded-full bg-[#3a3a3a]" />
              </div>
              <span className="font-mono text-[11px] text-ink-3">stack.sh</span>
              <span className="w-10" />
            </div>
            <div className="p-5 md:p-7 divide-y divide-rule">
              {categories.map((cat) => (
                <div
                  key={cat.label}
                  className="py-4 md:py-5 grid grid-cols-1 md:grid-cols-[200px_1fr] gap-3 md:gap-8"
                >
                  <div className="font-mono text-xs text-ink-3 md:pt-1.5">
                    <span className="text-accent">$</span> {cat.label}
                  </div>
                  <div className="flex flex-wrap gap-1.5">
                    {cat.items().map((s) => (
                      <span
                        key={s}
                        className="font-mono text-[11px] px-2.5 py-1 rounded-md border border-rule text-ink hover:border-accent/40 hover:text-accent transition-colors"
                      >
                        {s}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
